import { FormattedMessage, useIntl } from "react-intl";
import ControlledInput from "../../../../components/ControlledInputs/input";
import TranslationField from "./TranslationField";
import {
  FlowNameContainer,
  CountryFlagIcon,
  AddNewTranslate,
  TranslateWithButton,
} from "../styles";
import { FormRow } from "../../../../components/ControlledInputs/styles";
import brazilFlag from "../../../../assets/images/brazil-flag.png";
import ukFlag from "../../../../assets/images/uk-flag.png";

const FlowBasicInfo = ({
  control,
  formState,
  watch,
  availableTranslations,
  handleAddTranslation,
  handleRemoveTranslation,
  form,
  inactivate,
}) => {
  const intl = useIntl();
  const nameTranslations = watch("nameTranslations");

  // Calcular se deve mostrar o botão baseado no estado atual
  const hasTranslations =
    nameTranslations && Object.keys(nameTranslations).length > 0;
  const shouldDisableButton = hasTranslations;

  return (
    <>
      <FormRow alignCenter>
        <FlowNameContainer>
          <CountryFlagIcon
            src={
              intl.locale === "en" || intl.locale === "en-US"
                ? ukFlag
                : brazilFlag
            }
            alt="country icon"
            hasLabel={true}
          />
          <ControlledInput
            data-test="flow-name-input"
            disabled={inactivate}
            name="name"
            control={control}
            formState={formState}
            label="flow_name"
            placeholder={intl.formatMessage({
              id: "PLACEHOLDER_FLOW_NAME",
            })}
            required={true}
            max={100}
          />
        </FlowNameContainer>
      </FormRow>

      {/* Campos de Tradução */}
      {nameTranslations &&
        Object.keys(nameTranslations).map((translationKey) => (
          <TranslateWithButton key={translationKey}>
            <FormRow alignCenter>
              <TranslationField
                data-test={`flow-name-translation-${translationKey}`}
                inactivate={inactivate}
                name={`nameTranslations.${translationKey}`}
                control={control}
                formState={formState}
                translationKey={translationKey}
                onRemove={(key) => handleRemoveTranslation(key, form)}
                placeholder={intl.formatMessage({
                  id: "PLACEHOLDER_FLOW_NAME",
                })}
              />
            </FormRow>
          </TranslateWithButton>
        ))}

      {/* Botão para adicionar tradução */}
      <AddNewTranslate
        data-test="add-translation-flow"
        type="button"
        onClick={() =>
          !shouldDisableButton &&
          availableTranslations.length > 0 &&
          handleAddTranslation(availableTranslations[0], form)
        }
        disabled={shouldDisableButton || inactivate}
        style={{ marginTop: "16px", alignSelf: "flex-start" }}
      >
        <FormattedMessage id="add_another_translation" />
      </AddNewTranslate>
    </>
  );
};

export default FlowBasicInfo;
